export const ONESIGNAL_ID = '13092f95-eca8-49a3-9e5a-8afba7fbb076'

const releaseApi = 'https://api.aa-vision.com'
const stagingApi = 'https://vision-web-api-test.azurewebsites.net'
export const BASE_URL = stagingApi